import { Col, Row } from 'antd';
import { AppModal } from '../common';
import { useUniversityContext, useUserContext } from '@/context';
import { useTranslation } from 'react-i18next';

const ProfileModal = ({ open, hide }) => {

  const [t] = useTranslation(['common']);
  const { university } = useUniversityContext();
  const { profile } = useUserContext();
  const student = profile?.student;

  return (
    <AppModal
      footer={null}
      onCancel={hide}
      open={open}
      variant="nurture"
      title={t('common:labels.profile-info')}
      style={{ maxWidth: '90%' }}
    >
      <Row gutter={[0, 16]}>
        <Col span={24}>{t('common:labels.firstname')}: {profile.firstName}</Col>
        <Col span={24}>{t('common:labels.lastname')}: {profile.lastName}</Col>
        <Col span={24}>{t('common:labels.university')}: {university.universityLabel}</Col>
        <Col span={24}>{t('common:labels.grade')}: {student?.studyLevel?.name}</Col>
        <Col span={24}>{t('common:labels.study-major')}: {student?.studyMajor?.name}</Col>
        <Col span={24}>{t('common:labels.study-major-field')}: {student?.studyMajor?.description}</Col>
        <Col span={24}>{t('common:labels.entrance-type')}: {student?.entranceType}</Col>
        <Col span={24}>{t('common:labels.status-of', {
          value: t('common:labels.dormitory')
        })}: {student?.isDormitoryResident ? t('common:labels.has-accommodation') : t('common:labels.no-accommodation')}</Col>
        <Col span={24}>{t('common:labels.mobile-no')}: {profile.mobileNumber ? profile.mobileNumber : t('common:labels.empty-field')}</Col>
        <Col span={24}>{t('common:labels.email')}: {profile.email ? profile.email : t('common:labels.empty-field')}</Col>
      </Row>
    </AppModal>
  );
};

export default ProfileModal;
